
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';


function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
              <h1 style={{ fontSize: '2.5rem', color: '#222', marginBottom: 16 }}>Download Book of Badsha</h1>
              <p style={{ fontSize: '1.2rem', color: '#444', maxWidth: 500, textAlign: 'center', marginBottom: 32 }}>
                Discover the works of Badsha in one app. Read several exclusive PDFs and enjoy a seamless reading experience.
              </p>
              <a
                href="https://play.google.com/store/apps/details?id=algorixit.bookofbadsha"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '16px 32px',
                  background: '#4285f4',
                  color: '#fff',
                  borderRadius: 8,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  textDecoration: 'none',
                  boxShadow: '0 2px 8px rgba(66,133,244,0.15)',
                  transition: 'background 0.2s',
                }}
              >
                Download on Google Play
              </a>
            </div>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
